export default __webpack_public_path__ + "static/media/sc.c508641a.jpg";